import {GenericList} from './GenericList';
import {Department} from '../../models/Department';

export class DepartmentList extends GenericList<Department> {}
